import ApprovalPeluang from './ApprovalPeluang';

export default ApprovalPeluang;
